import { ExternalLink, Heart } from 'lucide-react';
import NextLink from 'next/link';

const Footer = () => (
  <footer role="contentinfo" className="w-full px-4 py-4">
    <hr className="border-border mb-4" />
    <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
      <p className="text-sm">
        Entwickelt mit{' '}
        <Heart className="-mt-0.5 inline-block h-5 w-5 -translate-x-0.5 fill-red-500 align-middle text-red-500" />
        von{' '}
        <a
          href="https://wotschofsky.com"
          target="_blank"
          rel="noopener noreferrer"
          className="underline underline-offset-2"
        >
          Felix Wotschofsky{' '}
          <ExternalLink className="mx-0.5 inline-block h-3 w-3" />
        </a>
      </p>
      <div className="flex flex-row gap-4">
        <NextLink
          href="/scanner"
          className="text-sm underline underline-offset-2"
        >
          Scanner
        </NextLink>
        <NextLink
          href="/verwaltung/teilnehmer"
          className="text-sm underline underline-offset-2"
        >
          Verwaltung
        </NextLink>
      </div>
      <p className="text-sm">
        <a
          href="https://royal-rangers-erlangen.de/impressum/"
          target="_blank"
          rel="noopener noreferrer"
          className="underline underline-offset-2"
        >
          Impressum & Datenschutz{' '}
          <ExternalLink className="mx-0.5 inline-block h-3 w-3" />
        </a>
      </p>
    </div>
  </footer>
);

export default Footer;
